import ScaleLoader from "react-spinners/ScaleLoader";
function Loader({ isLoading }) {
  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <ScaleLoader
            color="#002138"
            loading={true}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : null}
    </>
  );
}

export default Loader;
